(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jan-collection-header"]) return;
  try {
    
document.addEventListener('click', (event) => {
  document.querySelectorAll('.jan-nav-dropdown[open]').forEach((dropdown) => {
    if (!dropdown.contains(event.target) || event.target.closest('a')) dropdown.removeAttribute('open');
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.jan-nav-dropdown[open]').forEach((dropdown) => {
    dropdown.removeAttribute('open');
    dropdown.querySelector('summary').focus();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jan-shared-header"]) return;
  try {
    
document.addEventListener('click', (event) => {
  document.querySelectorAll('.jan-nav-dropdown[open]').forEach((dropdown) => {
    if (!dropdown.contains(event.target) || event.target.closest('a')) dropdown.removeAttribute('open');
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.jan-nav-dropdown[open]').forEach((dropdown) => {
    dropdown.removeAttribute('open');
    dropdown.querySelector('summary').focus();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jan-textile-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  document.querySelectorAll('.jan-nav-dropdown[open]').forEach((dropdown) => {
    if (!dropdown.contains(event.target) || event.target.closest('a')) dropdown.removeAttribute('open');
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.jan-nav-dropdown[open]').forEach((dropdown) => {
    dropdown.removeAttribute('open');
    dropdown.querySelector('summary').focus();
  });
});

  } catch(e) { console.error(e); }
})();
})();
